export const ENROLLMENT_ROUTE_NAMES = {
  COMPARE_PLANS: 'compare-plans',
  INVENTORY_INSIGHTS_ENROLLMENT: 'inventory-insights-enrollment',
};
